import { o365Data } from '../reporter/report/Report';
import ContentConfig from '../config/ContentConfig';
import ForbiddenError from '../error/ForbiddenError';
import RequestError from '../error/RequestError';
import getUrlPrefix from './getUrlPrefix';
import { PlayType } from '@kollective-frontend/ksdk-api';
import { SessionMetadata } from '../playback/interfaces';

interface SessionArgs {
  contentId: string;
  contentToken: string;
  playGuid: string;
  tenantId: string;
  o365?: o365Data;
  appUser?: string;
  browserUserGuid: string;
  title: string;
  version: string;
  playType: PlayType;
  sessionMetadata: SessionMetadata;
}

export default async function startSession(
  config: ContentConfig,
  {
    contentId,
    contentToken,
    playGuid,
    tenantId,
    o365,
    appUser,
    browserUserGuid,
    sessionMetadata,
    title,
    version,
    playType
  }: SessionArgs
): Promise<void> {
  const urlPrefix = getUrlPrefix(config);
  const url = `${urlPrefix}:${config.agent.port}/tenant/${tenantId}/content/${contentId}/session/${playGuid}/create`;

  const body = JSON.stringify({
    contentToken,
    o365,
    appUser,
    browserUserGuid,
    sessionMetadata,
    title,
    version,
    playType
  });

  const resp = await fetch(url, {
    method: 'POST',
    body
  });

  if (resp.ok) {
    return Promise.resolve();
  }
  switch (resp.status) {
    case 400:
      return Promise.reject(new RequestError('Bad Request', 400));
    case 403:
      return Promise.reject(new ForbiddenError());
    default:
      return Promise.reject(
        new RequestError(
          resp.statusText ? resp.statusText : 'Request failed',
          resp.status
        )
      );
  }
}
